export default {
  COOKIE_KEY_CURRENT_USER_ID:'member/current_user_id',
  list:[],
  listAll:[],
  listInfo:{},

  memberInfo:{},
  memberDetailPromise: null, // 회원 상세 정보를 가져오는 Promise 객체
}
